document.addEventListener('DOMContentLoaded', function(){
    function ham() {
        document.querySelector('#line1').classList.toggle('c-hamburger__line--first-active');
        document.querySelector('#line2').classList.toggle('c-hamburger__line--second-active');
        document.querySelector('#line3').classList.toggle('c-hamburger__line--third-active');
        document.querySelector('.c-hamburger').classList.toggle('c-hamburger-active');
        document.querySelector('#ham__nav').classList.toggle('nav--visible');
    }
    document.querySelector('#hamburger').addEventListener('click' , function() {
        ham();
    } );
} );

document.addEventListener('DOMContentLoaded', function() {
    scrollObserve('.c-fadein');
    scrollObserve('.c-left');
    scrollObserve('.c-right');
});

function scrollObserve(val) {
    const els = document.querySelectorAll(val);
    const cb = function(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
                observer.unobserve(entry.target); //1回で処理を停止
            } else {
                entry.target.classList.remove('is-active');
            }
        });
    }

    const io = new IntersectionObserver(cb);
    els.forEach(el => io.observe(el));
}

var scroll = new SmoothScroll('a[href*="#"]', {
    speedAsDuration:true,
    speed:1000,
});

window.addEventListener('scroll', function() {
    const start =  document.querySelector('.c-start');
    if (document.documentElement.scrollTop > 500) {
        start.classList.add('is-active');
    } else {
        start.classList.remove('is-active');
    }
})

document.addEventListener('DOMContentLoaded', function(){
    document.querySelector('.c-map__close').addEventListener('click' , function() {
        document.querySelector('.c-map').classList.add('is-passive');
    } );
} );

var swiper = new Swiper(".main-swiper", {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    speed: 2000,
});